export const OTP_LOGIN_ENDED = 'otp_login_ended'
export const SELECT_SIDE_ON_MOBILE = 'selected_image_side'

export const JOB_PROGRESS_MESSAGES = {
  'send-to-ebay': 'Listing to Ebay in progress',
  'send-to-collx': 'Listing to Collx in progress',
  'send-to-whatnot': 'Listing to Whatnot in progress',
  'send-to-shopify': 'Listing to Shopify in progress',
  'import-collx': 'Import from Collx in progress',
  'import-ebay': 'Import from Ebay in progress',
  'import-whatnot': 'Import from Whatnot in progress',
  'import-shopify': 'Import from Shopify in progress',
  'update-listing': 'Listing update in progress',
}